/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type CartRefetchContainer_viewer$ref = any;
export type CartRendererQueryVariables = {
    readonly userId: string;
    readonly userIds: ReadonlyArray<string | null>;
    readonly hasUserId: boolean;
    readonly localItemIds?: ReadonlyArray<string | null> | null;
    readonly fetchLocalItems: boolean;
    readonly loadPortfolioData: boolean;
};
export type CartRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": CartRefetchContainer_viewer$ref;
    } | null;
};
export type CartRendererQuery = {
    readonly response: CartRendererQueryResponse;
    readonly variables: CartRendererQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "localItemIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchLocalItems",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1
    } as any), v3 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 10
        } as any)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "portfolioId",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "portfolioItemId",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstPhotoWebPath",
        "args": [
            {
                "kind": "Literal",
                "name": "size",
                "value": "large"
            }
        ],
        "storageKey": "firstPhotoWebPath(size:\"large\")"
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pdpURL",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isArt",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdDate",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "creators",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemCreator",
        "plural": true,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "creator",
                "storageKey": null,
                "args": null,
                "concreteType": "Creator",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                    },
                    (v1 /*: any*/)
                ]
            },
            (v1 /*: any*/)
        ]
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "setSize",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasUnlimitedQuantity",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "vertical",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isFurniture",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v22 = [
        (v20 /*: any*/),
        (v21 /*: any*/)
    ], v23 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "convertedAmountList",
            "storageKey": null,
            "args": null,
            "concreteType": "ConvertedAmountList",
            "plural": true,
            "selections": (v22 /*: any*/)
        } as any)
    ], v24 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pricing",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPricing",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "purchasable",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "retailPrice",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": (v23 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "salePrice",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": (v23 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "netPrice",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": (v23 /*: any*/)
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "negotiable",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v25 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userId"
    } as any), v26 = [
        (v25 /*: any*/)
    ], v27 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v21 /*: any*/),
            (v20 /*: any*/)
        ]
    } as any), v28 = [
        (v27 /*: any*/)
    ], v29 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "lastTransaction",
        "storageKey": null,
        "args": (v26 /*: any*/),
        "concreteType": "Transaction",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isPrivateOffer",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "mostRecentDealerOffer",
                "storageKey": null,
                "args": null,
                "concreteType": "Offer",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isSubmitted",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v28 /*: any*/)
                    },
                    (v1 /*: any*/)
                ]
            },
            (v1 /*: any*/)
        ]
    } as any), v30 = ({
        "kind": "LinkedField",
        "alias": "cartPriceTableDisplayInfo",
        "name": "displayInfo",
        "storageKey": null,
        "args": (v26 /*: any*/),
        "concreteType": "ItemDisplayInfo",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "PriceInfoDisplay",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showSale",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showNet",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showRetail",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v31 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "shipmentQuotes",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isComplimentary",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "totalAmount",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    (v27 /*: any*/),
                    (v20 /*: any*/)
                ]
            },
            (v1 /*: any*/)
        ]
    } as any), v32 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "holds",
        "storageKey": null,
        "args": null,
        "concreteType": "Hold",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "expirationDate",
                "args": null,
                "storageKey": null
            },
            (v1 /*: any*/)
        ]
    } as any), v33 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "seller",
        "storageKey": null,
        "args": null,
        "concreteType": "Seller",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v1 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isClosed",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isPending",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isSuspended",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v34 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "ecommerceTrackingParams",
        "args": null,
        "storageKey": null
    } as any), v35 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "returnPolicy",
        "storageKey": null,
        "args": null,
        "concreteType": "ReturnPolicy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "accept",
                "args": null,
                "storageKey": null
            },
            (v1 /*: any*/)
        ]
    } as any), v36 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "displayInfo",
        "storageKey": null,
        "args": [
            (v25 /*: any*/),
            {
                "kind": "Literal",
                "name": "page",
                "value": "pdp"
            }
        ],
        "concreteType": "ItemDisplayInfo",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "ctas",
                "storageKey": null,
                "args": null,
                "concreteType": "CTADisplay",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showAcceptOffer",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showMakeOffer",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showPurchase",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showRequestPrice",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "PriceInfoDisplay",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showOnHold",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showOnHoldCustom",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showSold",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v37 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "quantitySelectOptions",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemQuantityOption",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "label",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "value",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v38 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isNotListed",
        "args": null,
        "storageKey": null
    } as any), v39 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
    } as any), v40 = ({
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any), v41 = [
        (v40 /*: any*/)
    ], v42 = [
        (v21 /*: any*/),
        (v20 /*: any*/),
        (v27 /*: any*/)
    ], v43 = ({
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isSold",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "retailPrice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v22 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "salePrice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v22 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "netPrice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v22 /*: any*/)
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "activePromotion",
                "storageKey": null,
                "args": (v41 /*: any*/),
                "concreteType": "Promotion",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "adjustmentRateList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                            (v5 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "reference",
                                "args": null,
                                "storageKey": null
                            },
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "flatAdjustmentRate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FlatAdjustmentRate",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "rate",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v42 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "eligibleAmount",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v28 /*: any*/)
                            },
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "percentAdjustmentRate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PercentAdjustmentRate",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "rate",
                                "args": null,
                                "storageKey": null
                            },
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "priceRange",
                        "name": "ruleList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                            (v5 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "type": "PriceRangeRule",
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "minAmount",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "FinancialAmount",
                                        "plural": false,
                                        "selections": (v42 /*: any*/)
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "maxAmount",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "FinancialAmount",
                                        "plural": false,
                                        "selections": (v42 /*: any*/)
                                    }
                                ]
                            }
                        ]
                    },
                    (v1 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "lastTransaction",
                "storageKey": null,
                "args": (v26 /*: any*/),
                "concreteType": "Transaction",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": "hasDealerSubmittedOfferAction",
                        "name": "hasAction",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "actionCode",
                                "value": "BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER"
                            }
                        ],
                        "storageKey": "hasAction(actionCode:\"BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER\")"
                    },
                    {
                        "kind": "ScalarField",
                        "alias": "hasAcceptedBuyerOfferAction",
                        "name": "hasAction",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "actionCode",
                                "value": "BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER"
                            }
                        ],
                        "storageKey": "hasAction(actionCode:\"BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER\")"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isInProcurement",
                "args": (v41 /*: any*/),
                "storageKey": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isOnHoldForDifferentBuyer",
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "currentBuyerId",
                                "variableName": "userId"
                            }
                        ],
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v44 = ({
        "kind": "Condition",
        "passingValue": true,
        "condition": "loadPortfolioData",
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "folderPortfolioItems",
                "name": "portfolioItems",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "portfolioType",
                        "value": "FOLDER"
                    },
                    (v40 /*: any*/)
                ],
                "concreteType": "PortfolioItemV2",
                "plural": true,
                "selections": [
                    (v5 /*: any*/),
                    (v1 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": "heartPortfolioItems",
                "name": "portfolioItems",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "portfolioType",
                        "value": "HEART"
                    },
                    (v40 /*: any*/)
                ],
                "concreteType": "PortfolioItemV2",
                "plural": true,
                "selections": [
                    (v7 /*: any*/),
                    (v8 /*: any*/),
                    (v1 /*: any*/)
                ]
            }
        ]
    } as any), v45 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalResults",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartRendererQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CartRefetchContainer_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CartRendererQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "loadPortfolioData",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "portfolioTypes",
                                            "value": [
                                                "HEART"
                                            ]
                                        },
                                        (v3 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v1 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "userRelationships",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "relationshipType",
                                            "value": "VIP"
                                        },
                                        (v3 /*: any*/)
                                    ],
                                    "concreteType": "UserRelationship",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "userDataB",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": null,
                                            "plural": true,
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "VipRepData",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "displayName",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "phoneNumber",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "formatType",
                                                                    "value": "INTERNATIONAL"
                                                                }
                                                            ],
                                                            "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "email",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        (v1 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "portfolioTypes",
                                            "value": [
                                                "CART"
                                            ]
                                        },
                                        (v3 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "items",
                                                            "storageKey": "items(first:10)",
                                                            "args": (v6 /*: any*/),
                                                            "concreteType": "PortfolioItemsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "edges",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PortfolioItemsEdge",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "node",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "PortfolioItemV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "item",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Item",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v9 /*: any*/),
                                                                                        (v10 /*: any*/),
                                                                                        (v11 /*: any*/),
                                                                                        (v12 /*: any*/),
                                                                                        (v13 /*: any*/),
                                                                                        (v14 /*: any*/),
                                                                                        (v15 /*: any*/),
                                                                                        (v16 /*: any*/),
                                                                                        (v17 /*: any*/),
                                                                                        (v18 /*: any*/),
                                                                                        (v19 /*: any*/),
                                                                                        (v24 /*: any*/),
                                                                                        (v29 /*: any*/),
                                                                                        (v30 /*: any*/),
                                                                                        (v31 /*: any*/),
                                                                                        (v32 /*: any*/),
                                                                                        (v4 /*: any*/),
                                                                                        (v33 /*: any*/),
                                                                                        (v34 /*: any*/),
                                                                                        (v35 /*: any*/),
                                                                                        (v36 /*: any*/),
                                                                                        (v37 /*: any*/),
                                                                                        (v38 /*: any*/),
                                                                                        (v39 /*: any*/),
                                                                                        (v1 /*: any*/),
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "categoryPath",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v43 /*: any*/),
                                                                                        (v44 /*: any*/)
                                                                                    ]
                                                                                },
                                                                                (v5 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "cursor",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                },
                                                                (v45 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "pageInfo",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "hasNextPage",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "endCursor",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedHandle",
                                                            "alias": null,
                                                            "name": "items",
                                                            "args": (v6 /*: any*/),
                                                            "handle": "connection",
                                                            "key": "CartItemList_items",
                                                            "filters": null
                                                        },
                                                        (v1 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v41 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canUseNetPrice",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                (v21 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isVerifiedTrade",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v1 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchLocalItems",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "items",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "itemIds",
                                            "variableName": "localItemIds"
                                        }
                                    ],
                                    "concreteType": "ItemsConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemsEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v4 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v29 /*: any*/),
                                                        (v30 /*: any*/),
                                                        (v31 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v35 /*: any*/),
                                                        (v36 /*: any*/),
                                                        (v37 /*: any*/),
                                                        (v38 /*: any*/),
                                                        (v39 /*: any*/),
                                                        (v43 /*: any*/),
                                                        (v44 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v45 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "CartRendererQuery",
            "id": "app-buyer-commerce/230.0.0-2019-08-28T11:45:44.689Z/CartRendererQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'ad012163aaddb7f536d1bcf892cd55d2';
export default node;
